/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import React from 'react';
import { hooks } from '@broadleaf/admin-components';
import classNames from 'classnames';
import * as qs from 'query-string';
import { useLocation, Link } from 'react-router-dom';

const { useHasAccess } = hooks;

const SetDealerLocationRowAction = props => {
  const { actionDefinition, row } = props;
  const location = useLocation();
  const hasAccess = useHasAccess(
    props.actionDefinition.scope,
    props.actionDefinition.operationType
  );
  const disabled = props.disabled || props.loading || !hasAccess;
  const [search, setSearch] = React.useState(
    qs.stringify({
      ...qs.parse(location.search),
      setApplicationId: row.id
    })
  );

  React.useEffect(() => {
    const s = qs.parse(location.search);
    s.setApplicationId = row.id;
    setSearch(qs.stringify(s));
  }, [location, row.id]);

  return (
    <Link
      className={classNames(
        'tw-inline-flex tw-items-center tw-px-4 tw-py-2',
        'tw-bg-green-700 tw-text-xs tw-font-bold tw-leading-none tw-text-white hover:tw-bg-green-800 hover:tw-text-white hover:tw-no-underline focus:tw-text-white focus:tw-no-underline active:tw-bg-green-600 active:tw-text-white',
        'rounded focus:tw-outline-none focus:tw-shadow-outline tw-appearance-none tw-shadow'
      )}
      disabled={disabled}
      to={l => ({ ...l, search })}
      style={{ opacity: disabled ? '0.65' : '1' }}
    >
      {actionDefinition.label}
    </Link>
  );
};

export default SetDealerLocationRowAction;
export { SetDealerLocationRowAction };
